module.exports = __webpack_public_path__ + "src/img/cropIcon.26afc1fa.svg";